<template>
	<div>
		<ld-popup
			class="popup-notificacao-ver"
			title=""
			:active.sync="activePopup"
			:button-close-hidden="true"
			:disabledBackgoundClose="false"
			:closed="closed"
		>
			<div>
				<h2 class="text-lg uppercase mb-1 break-all">
					{{ notificacao && notificacao.prazo ? notificacao.prazo.titulo : "" }}
				</h2>
				<h5 class="text-base font-normal break-all">
					{{
						notificacao
							? convertDate(
								notificacao.created_at,
								null,
								"DD/MM/YYYY [as] HH:mm"
							)
							: ""
					}}
				</h5>
			</div>

			<p class="px-2 my-10 text-lg">
				{{ notificacao ? notificacao.assunto : "" }}
			</p>

			<vs-divider />

			<div class="button-container">
				<div class="button-group flex justify-end">
					<vs-button
						class="w-32 mr-3"
						color="dark"
						type="flat"
						@click="closed"
						>Fechar</vs-button
					>
					<vs-button
						color="primary"
						type="filled"
						@click="() => editarPrazo(notificacao.prazo)"
						>Ver prazo</vs-button
					>
				</div>
			</div>
		</ld-popup>

		<popup-adicionar-prazo
			:active.sync="activePopupAdicionarPrazo"
			:prazoCopy="prazoDuplicate"
		/>

		<popup-editar-prazo
			:active.sync="activePopupEditarPrazo"
			:prazoPk="targetPrazoPk"
			:duplicate="onDuplicatePrazo"
		/>

	</div>
</template>

<script>
import DateHelper from "../../../../helpers/DateHelper";
import PopupAdicionarPrazo from "../../../prazo/calendario/components/simple_calendar/popup_adicionar_prazo/PopupAdicionarPrazo";
import PopupEditarPrazo from "../../../prazo/calendario/components/simple_calendar/popup_editar_prazo/PopupEditarPrazo";

export default {
	data() {
		return {
			prazoDuplicate: null,
			targetPrazoPk: null,
			activePopupEditarPrazo: false,
			activePopupAdicionarPrazo: false,
		};
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		},
		notificacao: {
			required: true
		}
	},
	components: {
		PopupAdicionarPrazo,
		PopupEditarPrazo,
	},
	computed: {
		activePopup: {
			set(value) {
				this.$emit("update:active", value);
			},
			get() {
				return this.active;
			}
		},
		convertDate() {
			return DateHelper.convertDate;
		}
	},
	methods: {
		onDuplicatePrazo(prazo) {
			this.prazoDuplicate = prazo;
			this.activePopupAdicionarPrazo = true;
		},
		editarPrazo(prazo) {
			this.targetPrazoPk = prazo.pk;
			this.activePopup = false;
			this.activePopupEditarPrazo = true;
		},
	}
};
</script>

<style lang="scss">
	.popup-notificacao-ver {
		.vs-popup {
			max-width: 850px;
		}
	}
</style>
